/* eslint-disable */
// import external dependencies
import 'jquery';

// Import everything from autoload
//;

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import buildPage from './routes/build';
import programPage from './routes/program';
import single from './routes/single';
import tourPage from './routes/tour';

const csv = require('./jquery.csv');

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Build page
  buildPage,
  programPage,
  // Single Page
  single,
  // Tour Page
  tourPage,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


//Header Setup
(()=>{
  const addPaddingForHero = () => {
    const setTopPadding = () => {
      const headerTopHeight =  document.querySelector('.top-header__inner').getBoundingClientRect().height;
      const headerBottomHeight =  document.querySelector('.header__inner').getBoundingClientRect().height;
      document.querySelector('main.main').style.marginTop = `${headerTopHeight + headerBottomHeight}px`;

    }
    setTopPadding();
    window.addEventListener('resize', () => {
      setTimeout(setTopPadding, 250)
    })
  }
  window.addEventListener('DOMContentLoaded', () => {
    addPaddingForHero()
  });
})();




// WEBPACK FOOTER //
// ./scripts/main.js